export default __webpack_public_path__ + "img/eDPQtHnd.1a67d751.svg";